module.exports = __webpack_public_path__ + "static/media/logo_polar.cad21f85.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo_polar.png
// module id = 557
// module chunks = 0